// extracted by mini-css-extract-plugin
export default {"formInputBox":"index_formInputBox_-aLpH","formSelect":"index_formSelect_KELuS","active":"index_active_Gt50q"};